import React, { PropTypes } from 'react';
import { safe_tags_replace } from 'common/utils';

const About = ({ about, hidden }) => {
  if (!about || hidden) {
    return null;
  }

  return (
    <div className="profile-about">
      <h2 className="section-title">About</h2>
      <div>{safe_tags_replace(about)}</div>
    </div>);
};

About.propTypes = {
  about: PropTypes.string,
  hidden: PropTypes.bool.isRequired,
};

export default About;



// WEBPACK FOOTER //
// ./profile/components/about.jsx